import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Notification from 'rc-notification';
// Replace react-export-excel with xlsx and file-saver
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import TextField from '@material-ui/core/TextField';
import SmallLoader from '../../../shared/components/SmallLoader';
import { vendorNameMapping } from '../helper'
import CustomerTable from './CustomerTable';
import { getCustomersData, handleLoader, handleTableLoader } from '../../../redux/actions/customerAction';

// Remove these lines as we're replacing with xlsx
// const { ExcelFile } = ReactExport;
// const { ExcelSheet, ExcelColumn } = ExcelFile;

const Customer = ({ dispatch, vendor }) => {
  const { customerData, isLoading, salesChannelFilterData, isTableLoading } = useSelector(
    ({ customerReducer, marketPlaceReducer }) =>
    ({
      customerData: customerReducer?.[vendor]?.customersData,
      isLoading: customerReducer?.[vendor]?.isLoading,
      isTableLoading: customerReducer?.[vendor]?.isTableLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel
    }),
  );
  const [customerdata, setData] = useState([]);
  const [searchAmazonOrderId, setAmazonOrderId] = useState("");
  const [searchBuyerName, setBuyerName] = useState("");
  const [searchAddress, setAddress] = useState("");

  // New function to handle Excel export using xlsx
  const exportToExcel = () => {
    try {
      // Transform the data to match your column structure
      const exportData = customerdata.map(item => ({
        'Amazon OrderID': item.amazonOrderId || '',
        'Buyer Name': item.buyerName || '',
        'SKU': item.sku || '',
        'Product Name': item.productName || '',
        'Quantity': item.quantityShipped || '',
        'Price': item.itemPrice || '',
        'Currency': item.currency || '',
        'Address1': item.shipAddress1 || '',
        'Address2': item.shipAddress2 || '',
        'City': item.shipCity || '',
        'State': item.shipState || '',
        'Postal Code': item.shipPostalCode || '',
        'Country': item.shipCountry || '',
        'SalesChannel': item.salesChannel || '',
        'Purchase Date': item.purchaseDate || ''
      }));

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Add the worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'customer');

      // Generate Excel file and save
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });

      saveAs(blob, `${vendorNameMapping[vendor]}_customers_${new Date().getFullYear()}.xlsx`);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error exporting to Excel. Please try again.',
          duration: 5,
          style: {top: 120, fontWeight: "bold", color: 'red'},
          maxCount: 10
        });
      });
    }
  };

  const callApi = ({ cpage, cpageSize }) => {
    dispatch(handleTableLoader(true, vendor));
    dispatch(getCustomersData({
      amazonOrderId: searchAmazonOrderId,
      name: searchBuyerName,
      address: searchAddress,
      page: cpage,
      pageSize: cpageSize,
      vendor
    }));
  }
  
  const handleApplySearch = () => {
    callApi({ cpage: "0", cpageSize: "250" })
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]} Customers Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

  useEffect(() => {
    dispatch(handleLoader(true, vendor));
    callApi({ cpage: "0", cpageSize: "250" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setData(customerData?.modal?.data || []);
  }, [customerData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        customerData?.modal?.data?.length > 0
      ) {
        setData(
          customerData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(customerData && customerData.modal && customerData.modal.data || []);
    }
  }, [customerData, salesChannelFilterData])

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            {vendorNameMapping[vendor]} Customers
          </CardTitle>
          <Row className="justify-content-space-between align-items-center mb-0">
            <Col sm="3" md="3">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="amazonOrderId"
                    label="Enter Amazon OrderID "
                    value={searchAmazonOrderId}
                    onChange={event => setAmazonOrderId(event.target.value)}
                    margin="normal"
                  />
                </div>
              </div>
            </Col>
            <Col sm="3" md="3">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="buyerName"
                    label="Enter Buyer Name "
                    value={searchBuyerName}
                    onChange={event => setBuyerName(event.target.value)}
                    margin="normal"
                  />
                </div>
              </div>
            </Col>
            <Col sm="3" md="3">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="address"
                    label="Enter Address "
                    value={searchAddress}
                    onChange={event => setAddress(event.target.value)}
                    margin="normal"
                    type="search"
                  />
                </div>
              </div>
            </Col>
            <Col md="3" className="p-0 filter-to-position">
              <div className="form__form-group">
                <button className="btn btn-sm btn-primary
                                             apply-date-button"
                  type="button" onClick={handleApplySearch}>
                  Apply</button>
                  <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
              </div>
            </Col>            
          </Row>
        </CardBody>
      </Card>
      <div id="divToPrint" ref={container}>
      <Row className="product-table-wrap">
        {isLoading ? (
          <Col sm="12">
            <CardBody>
              <div
                style={{ minHeight: '300px' }}
                className="row align-items-center justify-content-center"
              >
                <SmallLoader loading={isLoading} />
              </div>
            </CardBody>
          </Col>
        ) : (
          <>
            <div className="ExcelTable" id='dvTable'>
              {/* Replace the old ExcelFile component with a simple button */}
              <button 
                className="btn btn-primary btn-sm download"
                onClick={exportToExcel}
                disabled={isLoading || customerdata.length === 0}
                title="Download Excel file"
              >
                <span className="action-title">Download Excel</span>
              </button>
            </div>
            <CustomerTable data={customerdata} pageInfo={customerData?.paginationInfo}
              callback={callApi} isTableLoading={isTableLoading} />
          </>
        )}
      </Row>
      </div>
    </Container>
  )
}

Customer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(Customer);